<template>
  <tr>
    <td><p>{{team.name}}</p></td>
    <td><student-indicator :student="team.leader" :online="isStudentOnline(team.leader)" /></td>
    <td>
      <p>{{team.students.length}}</p>
      <ul v-if="expanded">
        <li v-for="student in team.students">
          <student-indicator :student="student" :online="isStudentOnline(student)" />
        </li>
      </ul>

    </td>
    <td class="actions">
      <button @click="$emit('electLeader', team); $refs['btn-elect-svg'].animate([{transform: 'rotate(360deg)'}], {duration: 750, easing: 'ease-in-out'})">
        <svg ref="btn-elect-svg" class="icon icon_arrow"><use xlink:href="#icon_refresh"></use></svg>
      </button>
      <button @click="expanded = !expanded" :class="{expanded}">
        <svg class="icon icon_dropdown"><use xlink:href="#icon_dropdown"></use></svg>
      </button>
    </td>
  </tr>
</template>

<script>
import StudentIndicator from "./StudentIndicator.vue";

export default {
  name: "TeamOverviewTeam",
  props: {
    team: Object,
    onlineStudents: [],
  },
  data(){
    return {
      expanded: false,
    };
  },
  components: {StudentIndicator},
  methods: {
    isStudentOnline(student){
      const uuid = student?.uuid;
      return this.onlineStudents.indexOf(uuid) != -1;
    },
  }
}
</script>

<style scoped>
  td {
    vertical-align: top;
  }

  td p {
    line-height: 30px;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  ul li {
    list-style: none;
  }

  .actions button {
    padding: 6px;
    border-radius: 6px;
    border: 1px solid rgba(210,214,220, 1);
  }

  .actions button:hover {
    background-color: rgba(210,214,220, 0.5);
  }

  .actions button svg {
    transition: transform 0.3s;
  }

  .actions button.expanded svg {
    transform: rotate(180deg);
  }
</style>
